import { MediaTrackingEvent } from '@tracker/mediaTracking/mediaTrackingModel';

export const mockTrackMediaEvents = async (
  mediaEvents: MediaTrackingEvent[],
): Promise<void> => {
  await Promise.resolve();
};
